module.exports = __webpack_public_path__ + "img/and.831bacef.png";